export enum TaxPayingCountryEnum {
    ONLY_IN_POLAND = 1,
    ANOTHER_COUNTRY = 2,
}

export const taxPayingCountryOptions: [string, string | number][] = [
    ['Wyłącznie w Polsce', TaxPayingCountryEnum.ONLY_IN_POLAND],
    ['W innym kraju', TaxPayingCountryEnum.ANOTHER_COUNTRY],
];
